import axios from 'axios';
import { makeAutoObservable } from 'mobx';

import User from './models/User';

export default class AuthStore {
    isProcess = true;
    isAuthenticateProcess = true;

    page = '';

    user: User | null = null;

    id!: string;
    token!: string;
    status!: string;

    get isAuthenticated() {
        return !!this.id && !!this.token && this.status !== 'unconfirmed';
    }

    constructor() {
        makeAutoObservable(this);

        this.authenticate();
    }

    async authenticate() {
        try {
            this.isProcess = true;
            this.isAuthenticateProcess = true;

            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/auth/authenticate`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('auth:token')}`,
                },
            });

            this.id = data.id;
            this.token = data.token;
            this.status = data.status;

            localStorage.setItem('auth:token', this.token);
        } catch (err) {
            this.id = '';
            this.token = '';
            this.status = '';

            localStorage.removeItem('auth:token');

            throw err;
        } finally {
            this.isProcess = false;
            this.isAuthenticateProcess = false;
        }
    }

    async login(email: string, password: string) {
        try {
            this.isProcess = true;

            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, {
                email,
                password,
            });

            this.id = data.id;
            this.token = data.token;
            this.status = data.status;

            localStorage.setItem('auth:token', this.token);
        } catch (err) {
            this.id = '';
            this.token = '';
            this.status = '';

            localStorage.removeItem('auth:token');

            throw err;
        } finally {
            this.isProcess = false;
        }
    }

    async loginFacebook(id: string, token: string) {
        try {
            this.isProcess = true;

            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/auth/connect/facebook`, {
                id,
                token,
            });

            this.id = data.id;
            this.token = data.token;
            this.status = data.status;

            localStorage.setItem('auth:token', this.token);
        } catch (err) {
            this.id = '';
            this.token = '';
            this.status = '';

            localStorage.removeItem('auth:token');

            throw err;
        } finally {
            this.isProcess = false;
        }
    }

    async loginGoogle(id: string, token: string) {
        try {
            this.isProcess = true;

            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/auth/connect/google`, {
                id,
                token,
            });

            this.id = data.id;
            this.token = data.token;
            this.status = data.status;

            localStorage.setItem('auth:token', this.token);
        } catch (err) {
            this.id = '';
            this.token = '';
            this.status = '';

            localStorage.removeItem('auth:token');

            throw err;
        } finally {
            this.isProcess = false;
        }
    }

    async signup(email: string, password: string) {
        try {
            this.isProcess = true;

            await axios.post(`${process.env.REACT_APP_API_URL}/auth/signup`, {
                email,
                password,
            });
        } finally {
            this.isProcess = false;
        }
    }

    async confirm(email: string) {
        try {
            this.isProcess = true;

            await axios.post(`${process.env.REACT_APP_API_URL}/auth/request/confirm`, {
                email,
            });
        } finally {
            this.isProcess = false;
        }
    }

    async confirmVerify(email: string, code: string) {
        try {
            this.isProcess = true;

            await axios.post(`${process.env.REACT_APP_API_URL}/auth/verify/confirm`, {
                email,
                code,
            });
        } finally {
            this.isProcess = false;
        }
    }

    async recovery(email: string) {
        try {
            this.isProcess = true;

            await axios.post(`${process.env.REACT_APP_API_URL}/auth/request/recovery`, {
                email,
            });
        } finally {
            this.isProcess = false;
        }
    }

    async recoveryVerify(email: string, code: string) {
        try {
            this.isProcess = true;

            await axios.post(`${process.env.REACT_APP_API_URL}/auth/verify/recovery`, {
                email,
                code,
            });
        } finally {
            this.isProcess = false;
        }
    }

    async recoveryReset(email: string, password: string, code: string) {
        try {
            this.isProcess = true;

            await axios.post(`${process.env.REACT_APP_API_URL}/auth/verify/password`, {
                email,
                password,
                code,
            });
        } finally {
            this.isProcess = false;
        }
    }

    async logout() {
        try {
            this.isProcess = true;

            await axios.post(`${process.env.REACT_APP_API_URL}/auth/logout`);
        } finally {
            this.id = '';
            this.token = '';

            localStorage.removeItem('auth:token');

            this.isProcess = false;
        }
    }
}
